<!--
마감 작업
-->
<template>
    <div class="">
        <div uk-grid class="uk-grid-small">
            <div class="uk-width-auto">
                <!-- 선택 일괄기능 -->
                <app-batch-controller
                    :batch="batch"
                    class="uk-margin-bottom"
                    hide-none-checked
                >
                    <app-batch-job-end
                        slot="jobs"
                        :batch="batch"
                        :csrf-token="csrfToken"
                        :region-id="regionId"
                    ></app-batch-job-end>
                </app-batch-controller>
            </div>

            <div class="uk-width-expand">

                <!-- 스캔 -->
                <div class="uk-card uk-card-default uk-card-large uk-margin-bottom" v-on:click="focusScanInput">
                    <div class="uk-card-body uk-text-center">


                        <p v-show="! scanned_msg" class="uk-text-center uk-text-large3" >
                            출고할 BOX의 운송장을 스캔한 뒤 마대에 담으세요
                        </p>

                        <p v-show="scanned_msg" class="uk-text-center uk-text-large3" :class="msgClass" >
                            {{ scanned_msg }}<br />
                            <span class="uk-text-muted">
                                SCANNED : {{ scanned_val }}
                            </span>
                        </p>

                        <!-- 스캔 폼 -->
                        <input
                            class="uk-input uk-width-1-1 uk-form-large"
                            placeholder="SHIPPING LABEL SCAN"
                            id="scan"
                            v-model.trim="scan"
                            v-on:keyup.enter="scanAjax"

                        />

                    </div>
                </div>


            </div>


        </div>
        
        <div class="uk-card uk-card-default uk-card-small">
            <div class="uk-card-header uk-flex uk-flex-between">
                <div class="uk-text-large">마감대상 ({{items.length}})</div>

                <div class="uk-text-large uk-text-muted">
                  당일 출고가 불가능한 BOX는 반드시 [출고보류] 하세요
                </div>
            </div>
            <div class="uk-card-body app-table-normal">

                <!-- 리스트 -->
                <table class="uk-table uk-table-small uk-table-middle">
                <colgroup>
                    <col style="width: 60px">
                    <col style="width: 150px">

                    <col style="width: 120px">
                    <col style="width: 150px">
                    
                    <col>
                    <col>

                    <col style="width: 120px">
                    <col style="width: 200px">

                    <col style="width: 230px">

                </colgroup>

                <thead>
                <tr>
                    <th scope="col" class="uk-text-center">
                        <app-batch-all-item-checker :items="batch.items"></app-batch-all-item-checker>
                    </th>
                    <th scope="col" class="uk-text-center">
                        배송코드
                    </th>

                    <th scope="col" class="uk-text-center">
                        배송단계
                    </th>
                    <th scope="col" class="uk-text-center">
                        수취인
                    </th>

                    <th scope="col" class="uk-text-center">
                        BLNO
                    </th>
                    <th scope="col" class="uk-text-center">
                        HAWB
                    </th>

                    <th scope="col" class="uk-text-center">
                        PACKAGE-QTY
                    </th>
                    <th scope="col" class="uk-text-center">
                        회원사서함
                    </th>

                    <th scope="col" class="uk-text-center">
                        출고보류
                    </th>
                </tr>
                </thead>
                <tbody>
                <tr
                    v-for="(item, index) in items"
                    :key="index"
                >
                
                    <td class="uk-text-center">
                        <app-batch-item-checker :item="item.checkbox"></app-batch-item-checker>
                    </td>
                    <td class="uk-text-center">
                        {{ item.code }}

                        <!-- 상세링크 -->
                        <a 
                            class="uk-link" 
                            :href="'/prods/' + item.first_prod_id" 
                            target="_blank"
                            title="상품상세"
                        >
                            <span uk-icon="'ratio: 1; icon: link"></span>
                        </a>
                        
                    </td>

                    <td class="uk-text-center">
                        {{ item.state_text }}
                    </td>
                    <td class="uk-text-center">
                        {{ item.name }}
                    </td>

                    <td class="uk-text-center">
                        {{ item.blno }}
                    </td>
                    <td class="uk-text-center">
                        {{ item.hawb }}
                    </td>

                    <td class="uk-text-center">
                        {{ item.package_amount }}
                    </td>
                    <td class="uk-text-center">
                        {{ item.user_mailbox }}
                    </td>

                    <td class="uk-text-center">
                        <!-- 출고보류 -->
                        <button
                                class="uk-button uk-button-small uk-button-g-w-lg uk-button-on-r-w-r"
                                type="button"

                                v-on:click="popHolding(item)"
                        >
                            <span uk-icon="'ratio: 1; icon: lock"></span>
                            <span class="uk-text-middle">HOLDING (출고보류)</span>
                        </button>
                    </td>

                </tr>
                
                </tbody>
                </table>
            </div>
        </div>



        <!-- 출고보류 폼 -->
        <div id="modal-holding" class="uk-flex-top" uk-modal esc-close="false" bg-close="false">
            <!-- 입력 폼 -->
            <div v-show="!isDoneHolding" class="uk-modal-dialog uk-margin-auto-vertical uk-width-xxlarge">

                <div class="uk-modal-header">
                    <h2 class="uk-modal-title">BOX HOLDING (출고보류 설정)</h2>
                </div>

                
                <div class="uk-modal-body uk-padding-small">
                    <!-- 선택된 배송건 정보 -->
                    <ul>
                        <li>
                            배송코드 : {{ itemToHold.code }}
                        </li>
                        <li>
                            배송단계 : {{ itemToHold.state_text }}
                        </li>
                        <li>
                            수취인 : {{ itemToHold.name }}
                        </li>
                        <li>
                            회원사서함 : {{ itemToHold.user_mailbox }}
                        </li>
                    </ul>

                    <hr />

                    <app-input-ex
                            class="uk-margin-bottom"
                            type="textarea"
                            v-model="holdReason"
                            label="출고보류 사유"
                            :textarea-rows="3"
                            placeholder="출고보류 사유를 입력하세요"
                    ></app-input-ex>

                    <app-input-ex
                            type="text"
                            v-model="holdStorage"
                            label="보관장소"
                            placeholder="BOX가 보관되는 위치를 반드시 입력하세요"
                    ></app-input-ex>

                </div>


                <div class="uk-modal-footer uk-text-right">
                    <p class="uk-text-danger uk-text-large">
                        정말 출고보류 설정합니까?
                    </p>
                    <button class="uk-button uk-button-default uk-modal-close" type="button"><span uk-icon="icon: close"></span> CANCEL</button>
                    <button class="uk-button uk-button-danger" type="button" @click="ajaxHolding">
                        <span uk-icon="icon: lock"></span> HOLDING (출고보류)
                    </button>
                </div>
            </div>

            <!-- 설정완료 화면 -->
            <div v-show="isDoneHolding" class="uk-modal-dialog uk-margin-auto-vertical uk-width-xxlarge">

                <div class="uk-modal-header">
                    <h2 class="uk-modal-title uk-text-danger">HOLDING BOX (출고보류)</h2>
                </div>

                
                <div class="uk-modal-body uk-padding-small">
                    <!-- 선택된 배송건 정보 -->
                    <ul>
                        <li>
                            배송코드 : {{ itemToHold.code }}
                        </li>
                        <li>
                            배송단계 : {{ itemToHold.state_text }}
                        </li>
                        <li>
                            수취인 : {{ itemToHold.name }}
                        </li>
                        <li>
                            회원사서함 : {{ itemToHold.user_mailbox }}
                        </li>
                    </ul>

                    <hr />

                    <div class="uk-text-center uk-margin-bottom">
                        <span class="uk-text-large">출고보류 설정이 완료되었습니다.</span><br />
                        라벨 부착 후 입력한 보관장소에 갖다놓으세요<br />
                        출고보류 처리가 끝난 후 [DONE (완료)] 버튼을 클릭하세요.<br />

                        
                    </div>

                    <div class="uk-text-center">
                        <!-- 라벨출력 -->
                        <button
                                type="button"
                                class="uk-button uk-button-danger"
                                onclick="$.app.print.shipout_hold_label(arguments);"
                                :data-house-id="itemToHold.id"
                                title="출고보류 라벨을 출력합니다"
                        >
                            <i class="material-icons uk-text-middle">print</i>
                            <span class="uk-text-middle">PRINT HOLD-LABEL (출고보류 라벨)</span>
                        </button>
                    </div>
    
                    <hr />

                    <!-- 보관장소 -->
                    <app-column
                        uk-icon="location"
                        header="보관장소"
                    >
                        {{ holdStorage }}
                    </app-column>

                </div>


                <div class="uk-modal-footer uk-text-center">
                    <button
                            type="button"
                            class="uk-button uk-button-primary uk-button-large"
                            onclick="$.app.refresh();"
                            title="출고보류 작업을 완료하고, 현재 페이지를 새로고침 합니다"
                    >
                        <span uk-icon="icon: check"></span>
                        DONE (완료)
                    </button>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        props: {
            /**
             * 라라벨 csrf 토큰
             */
            csrfToken: {
                type: String,
                default: null,
            },
            /**
             * 하우스정보
             */
            items: {
                type: Array,
                default: [],
            },
            /**
             * 지역id
             */
            regionId: {
                type: Number,
                default: null,
            },
        },
        data: function () {
            // batch items 생성 (전체선택에 사용할 일괄정보 객체)
            let batch_items = [];
            _.forEach(this.items, function (item) {
                let obj = {
                    id: item.id,
                    checked: false,

                    code: item.code,
                    //id: item.id,
                    name: item.name,
                    state_text: item.state_text,
                    blno: item.blno,
                    hawb: item.hawb,
                    package_amount: item.package_amount,
                    user_nick: item.user_nick,
                    user_mailbox: item.user_mailbox,

                    first_prod_id: item.first_prod_id,
                };
                item.checkbox = obj;
                batch_items.push(obj);
            });
            return {
                // 스캔 입력값
                scan: null,
                // 스캔결과 - 메세지
                scanned_msg: null,
                // 스캔결과 - 성공여부
                scanned_is_succ: false,
                // 스캔결과 - 스캔된 번호
                scanned_val: '',

                // 출고보류 폼에 선택된 item
                itemToHold: {},

                // 출고보류 폼 - 사유
                holdReason: null,

                // 출고보류 폼 - 보관장소
                holdStorage: null,

                // 출고보류 완료여부
                isDoneHolding: false,

                // 전체선택에 사용할 일괄정보 객체
                batch: {
                    items: batch_items,
                    checked_item_count: 0,
                    item_checked_msg_format: 'checked :count items',
                    item_checked_nothing_msg: 'No item selected',
                },

                /**
                 * 사운드
                 * https://hearling.com
                 **/
                sound: {
                    ok: null,
                    fail: null,
                    not_found: null,
                },
            };
        },
        computed: {
            /**
             * 스캔 결과메세지 class
             */
            msgClass: function () {
                return this.scanned_is_succ ? 'uk-text-primary' : 'uk-text-danger';
            }
        },
        watch: {
        },
        mounted: function () {
            // 사운드 preload
            this.sound.ok = new Audio('/end-sound/ok.mp3');
            this.sound.fail = new Audio('/end-sound/fail-try-again.mp3');
            this.sound.not_found = new Audio('/end-sound/not-found.mp3');

        },
        methods: {
            /**
             * 스캔 input 포커싱
             */
            focusScanInput: function () {
              $('#scan').focus()
            },

            /**
             * 스캔 ajax 처리
             */
            scanAjax: function () {
                let cmp = this;

                // 값이 있는지 검증
                if (! cmp.scan) {
                  cmp.setScannedError('NO SCANNED');
                  return;
                }

                // ajax 옵션
                let opts = {
                    type: 'patch',
                    url: '/regions/'+cmp.regionId+'/end-targets/scan',
                    data: {
                        '_token': cmp.csrfToken,
                        'scan': cmp.scan
                    },
                    success: function (response, textStatus, jqXHR) {
                        // 성공
                        //console.log('success : '+response.id);
                        cmp.setScannedSucc('SUCCESS !');

                        // 아이템 제거
                        _.remove(cmp.items, function (item) {
                            return item.id === response.house_id;
                        });
                    },
                    alert_error_msg: function(msg, code){
                        // 오류
                        //console.log('error : '+msg);
                        cmp.setScannedError(msg, code);

                    },
                    complete: function(jqXHR, textStatus){

                        // 텍스트 초기화
                        cmp.scan = '';
                        cmp.focusScanInput();

                    }
                };

                // ajax 실행
                $.app.ajax.module.default(opts);

            },

            /**
             * 스캔 결과작성
             */
            setScannedSucc: function (msg) {
                this.scanned_msg = msg;
                this.scanned_val = this.scan;
                this.scanned_is_succ = true;

                // 사운드 출력
                this.sound.ok.play();
            },
            /**
             * 스캔 결과작성
             */
            setScannedError: function (msg, code) {
                this.scanned_msg = msg;
                this.scanned_val = this.scan;
                this.scanned_is_succ = false;

                // 사운드 출력
                if (code === 9) {
                    // 운송장 조회 실패 오류
                    this.sound.not_found.play();
                } else {
                    // 기타 오류
                    this.sound.fail.play();
                }

            },

            /**
             * 출고보류설정 - 입력폼 띄우기
             */
            popHolding: function (item) {
                let cmp = this;

                // 출고보류 아이템에 저장
                cmp.itemToHold = item;

                // 모달
                var $modal = $('#modal-holding');

                // 팝
                UIkit.modal($modal).show();
            },
           
            /**
             * 출고보류설정 - ajax
             */
            ajaxHolding: function () {
                let cmp = this;
                // console.log(cmp.itemToHold.name);

                // ajax 옵션
                let opts = {
                    type: 'post',
                    url: '/houses/'+cmp.itemToHold.id+'/shipout-holds',
                    data: {
                        '_token': cmp.csrfToken,
                        'hold_reason': cmp.holdReason,
                        'storage': cmp.holdStorage,
                    },
                    success: function (response, textStatus, jqXHR) {
                        // 성공시, 출고보류결과 화면으로 전환
                        cmp.isDoneHolding = true;
                    },
                };

                // ajax 실행
                $.app.ajax.module.default(opts);
            },
           

        }
    }
</script>

<style lang="scss" scoped>
    #scan {
        text-align: center;
        font-size: 2rem;
        color: #0e6ecd;
    }
</style>